import {TreeNode} from '@hconnect/common/types'
import {dataTestId} from '@hconnect/uikit'
import {Box, Stack} from '@mui/material'
import React from 'react'

import {isDepartmentOrEquipmentNode} from '../../helpers'

import {DepartmentEnglishNameForm} from './DepartmentEnglishNameForm'
import {EnabledForPlanningItemData} from './EnabledForPlanningItemData'

interface DepartmentGeneralProps {
  selectedItem: TreeNode
}

export const DepartmentGeneral: React.FC<DepartmentGeneralProps> = ({selectedItem}) => {
  const isDisabled =
    !isDepartmentOrEquipmentNode(selectedItem) || !selectedItem.enabledForPlanningItem
  return (
    <Stack spacing={3} {...dataTestId('department_general_container')}>
      <Box
        sx={{
          border: (theme) => `1px solid ${theme.palette.grey[300]}`,
          borderRadius: 1,
          p: 3
        }}
        {...dataTestId('department_general_english_name_section')}
      >
        <DepartmentEnglishNameForm departmentUpmId={selectedItem.upmId} />
      </Box>
      {!isDisabled && (
        <Box
          sx={{
            border: (theme) => `1px solid ${theme.palette.grey[300]}`,
            borderRadius: 1,
            p: 3
          }}
          {...dataTestId('department_general_asset_data_section')}
        >
          <EnabledForPlanningItemData />
        </Box>
      )}
    </Stack>
  )
}
